import React, { useEffect, useState } from 'react';
import { Input, Button, Modal, notification } from 'antd';
import GenericTable from '../components/GenericTable'; // Generic Table Component
import GenericModal from '../components/GenericModal'; // Generic Modal Component for Create/Edit
import GenericViewModal from '../components/GenericViewModal'; // Generic View Modal Component
import ProjectNavbar from '../components/ProjectNavbar';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateCurrentProjectId } from '../redux-saga/actions/customerActions';

const { Search } = Input;

const initialFilesData = [
  {
    "name": "Project Overview",
    "content": "Overview of the project objectives and goals.",
    "type": "doc",
    "size": 512,
    "url": "https://example.com/files/project-overview.doc",
    "status": "active",
    "created at": "2024-10-01T10:00:00Z",
    "modified at": "2024-10-10T12:30:00Z"
  },
  {
    "name": "Design Mockup",
    "content": "Mockup of the homepage design.",
    "type": "jpg",
    "size": 1024,
    "url": "https://example.com/files/design-mockup.jpg",
    "status": "active",
    "created at": "2024-09-20T09:15:00Z",
    "modified at": "2024-09-25T14:45:00Z"
  },
  // Add more files as needed
];

const ProjectFilePage = () => {
  const [filesData, setFilesData] = useState(initialFilesData); // File data state
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();
  const {id}=useParams()
  const [isModalVisible, setIsModalVisible] = useState(false); // Manage create/edit modal
  const [isViewModalVisible, setIsViewModalVisible] = useState(false); // Manage view modal
  const [editingFile, setEditingFile] = useState(null); // Manage current editing file
  const [viewingFile, setViewingFile] = useState(null); // Manage file being viewed


  useEffect(() => {
    dispatch(updateCurrentProjectId(id));
  }, [])
  // Handle search functionality
  const filteredFiles = filesData.filter((file) =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Config for table columns
  const columnsConfig = [
    { title: 'Name', dataIndex: 'name', sortable: true },
    { title: 'Type', dataIndex: 'type', sortable: true },
    { title: 'Size (KB)', dataIndex: 'size' },
    { title: 'Status', dataIndex: 'status', sortable: true },
    { title: 'Created At', dataIndex: 'created at', sortable: true },
    { title: 'Modified At', dataIndex: 'modified at', sortable: true },
  ];

  // Actions for table
  const actions = ['View', 'Edit', 'Delete'];

  // Handle action functions
  const actionFunctions = [
    (record) => handleView(record), // View action
    (record) => handleEdit(record), // Edit action
    (record) => handleDelete(record), // Delete action
  ];

  // Handle View file details
  const handleView = (record) => {
    setViewingFile(record);
    setIsViewModalVisible(true);
  };

  // Handle Edit file
  const handleEdit = (record) => {
    setEditingFile(record);
    setIsModalVisible(true);
  };

  // Handle Delete file
  const handleDelete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this file?',
      onOk: () => {
        setFilesData(filesData.filter((file) => file.name !== record.name));
        notification.success({ message: 'File deleted successfully' });
      },
    });
  };

  // Handle Create or Edit File submission
  const handleSubmit = (values) => {
    if (editingFile) {
      // Edit existing file
      const updatedFiles = filesData.map((file) =>
        file.name === editingFile.name ? { ...file, ...values } : file
      );
      setFilesData(updatedFiles);
      notification.success({ message: 'File updated successfully' });
    } else {
      // Create new file
      setFilesData([...filesData, values]);
      notification.success({ message: 'File created successfully' });
    }
    setIsModalVisible(false);
    setEditingFile(null);
  };

  // Modal form fields configuration
  const modalInputs = [
    { label: 'File Name', name: 'name', type: 'text', required: true, placeholder: 'Enter file name' },
    { label: 'Content', name: 'content', type: 'textarea', required: true, placeholder: 'Enter file content' },
    { label: 'File Type', name: 'type', type: 'text', required: true, placeholder: 'doc, jpg, pdf, etc.' },
    { label: 'Size (KB)', name: 'size', type: 'number', required: true, placeholder: 'File size in KB' },
    { label: 'Status', name: 'status', type: 'text', required: true, placeholder: 'active, archived' },
    { label: 'URL', name: 'url', type: 'text', required: true, placeholder: 'File URL' },
    { label: 'Created At', name: 'created at', type: 'text', required: true },
    { label: 'Modified At', name: 'modified at', type: 'text', required: true },
  ];

  return (
    <div style={{display:"flex"}}>
    <ProjectNavbar/>
    <div style={
        {
            width:"100%",
            padding:"20px"
        }
    }>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'end' }}>
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          Create File
        </Button>
      </div>

      {/* File List Table */}
      <GenericTable
        data={filteredFiles}
        columnsConfig={columnsConfig}
        searchKeys={['name']}
        actions={actions}
        actionFunctions={actionFunctions}
      />

      {/* Create/Edit Modal */}
      {isModalVisible && (
        <GenericModal
          isVisible={isModalVisible}
          handleOk={handleSubmit}
          handleCancel={() => setIsModalVisible(false)}
          title={editingFile ? 'Edit File' : 'Create File'}
          inputs={modalInputs}
          predefinedData={editingFile || {}}
        />
      )}

      {/* View Modal */}
      {isViewModalVisible && (
        <GenericViewModal
          isVisible={isViewModalVisible}
          handleCancel={() => setIsViewModalVisible(false)}
          title={viewingFile.name}
          data={viewingFile}
          footerButtons={["Close"]}
          onButtonClick={() => setIsViewModalVisible(false)}
        />
      )}
    </div>
    </div>
  );
};

export default ProjectFilePage;
